import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Switch, Route, Redirect } from 'react-router';
import { useSelector } from 'react-redux';
import { GeneralRouterTabs, ErrorBoundary } from 'sharedComponents';
import { getTabOptions } from './helpers';
import { ConditionIndicesOverviewV2 } from './ConditionIndicesOverviewV2';
import { MaintenanceOverviewLazyV2 } from './MaintenanceOverviewV2';
import { CrossAssetAnalysisV2 } from './CrossAssetAnalysisV2';
import featureConfigHelper from 'helpers/featureConfigHelper';
import UserCapabilityHelper from 'helpers/userCapabilityHelper';

const PowertrainConditionMonitoringComponent = () => {
    const { t: translate } = useTranslation();
    const capabilities = useSelector(state => state?.overview?.userCapabilities);
    const featureConfig = new featureConfigHelper();
    const [tabOptions, setTabOptions] = useState(getTabOptions(translate, capabilities));
    const userCapabilities = new UserCapabilityHelper(capabilities);

    useEffect(() => {
        setTabOptions(getTabOptions(translate, capabilities));
    }, [translate]);

    return (
        <div className='general-page-content'>
            <GeneralRouterTabs
                options={tabOptions}
                variant='primary'
                removeSearchFilter={true}
            >
                <Switch>
                    {userCapabilities.hasConditionOverviewV2() &&
                        <Route Route path={tabOptions.conditionOverviewV2.route}>
                            <ConditionIndicesOverviewV2 />
                        </Route>
                    }
                    {featureConfig.isCBMFeatureEnabled() && userCapabilities.hasAdvancedAnalyticsV2Capability() &&
                        <Route path={tabOptions.maintenanceOverviewV2?.route}>
                            <MaintenanceOverviewLazyV2 />
                        </Route>
                    }
                    {userCapabilities.hasCrossAssetAnalysisV2() &&
                        <Route exact path={tabOptions.crossAssetAnalysisV2?.route}>
                            <ErrorBoundary onReportIssue={() => { }}>
                                <CrossAssetAnalysisV2 />
                            </ErrorBoundary>
                        </Route>
                    }
                    <Route path={tabOptions.cbm.route}>
                        <div>
                            Work in progress...
                        </div>
                    </Route>
                    <Redirect from='*' to={tabOptions?.conditionOverviewV2?.route} />
                </Switch>
            </GeneralRouterTabs>
        </div >
    );
};

export default PowertrainConditionMonitoringComponent;
